import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const Dato = ({styles, elemento}) => {
  return(
    <div>
      <div className="right floated content">
        <p style={styles.elemLis_2}>{elemento.codigoCiudad} ={">"} {elemento.nombreCiudad}</p>
      </div>
      <div className="floated content">
        <p style={styles.elemLis_1} className="header">{elemento.codigoZona} ={">"} {elemento.nombreZona}</p>
      </div>
    </div>
  )};

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
      <div className="item">
        <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
            <List.Header>
                <div className="floated content" style={styles.subElemLis_1}>
                    <a className="header"><Dato styles={styles} elemento={elemento}/></a>
                </div>
            </List.Header>
        </List.Item>
      </div>
    </div>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={i} />);
  return(
    <div>
      {nivel1Detalle}
    </div>
  )
};

const DirZon2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
    const lista = []
    list.forEach((elemento, _id) => {
        if(elemento.ciudades.length>0){
            elemento.ciudades.forEach((elemento1, i) => {
                if(elemento1.zonas.length>0){
                    elemento1.zonas.forEach((elemento2, ii) => {
                        if(elemento2.codigoZona!==null){
                            lista.push({_id: elemento._id, codigoDpto: elemento.codigoDpto, codigoCiudad: elemento1.codigoCiudad, nombreCiudad: elemento1.nombreCiudad, codigoZona: elemento2.codigoZona, nombreZona: elemento2.nombreZona})
                        }
                    })
                }
            })
        }
    })
    function ordenarAsc(array, campo) {
        array.sort(function (a, b) {
           return a[campo] > b[campo];
        });
     }
     ordenarAsc(lista, 'codigoZona')

     const a01051001 = autorizacUA.findIndex( autorizac => autorizac === "01051001" );

    return (
    <div>
      <List selection>
      <TitDer list={lista} textBoton1="Zonas" btnNuevo={a01051001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <Lista list={lista} styles={styles} handleClickidLista={handleClickidLista}/>
      </List>
    </div>
  )
};

export default DirZon2
